// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"screen-fetching-module__spinnerWrapper___1OgAE screen-module__screen___1M2JT"};